import { createContext, ReactNode, useContext } from 'react'

// true khi GET /customers/:id trả viewer_access === 'lead_origin_readonly'
// (Marketing xem KH convert từ lead mà họ không follow). Mặc định false để mọi
// nơi dùng component ngoài trang chi tiết giữ nguyên hành vi.
const CustomerReadOnlyContext = createContext<boolean>(false)

export const CustomerReadOnlyProvider = ({
    isReadOnly,
    children,
}: {
    isReadOnly: boolean
    children: ReactNode
}) => (
    <CustomerReadOnlyContext.Provider value={isReadOnly}>
        {children}
    </CustomerReadOnlyContext.Provider>
)

export const useCustomerReadOnly = () => useContext(CustomerReadOnlyContext)
